module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Ultralight.ee44b143.ttf";